import Service, { type Registry as Services, service } from '@ember/service';
import type { ComparisonSet } from 'frontend-utils/utils/constants/benchmark-insight';
import { BENI_COMPARISON_SET_LONG_TRANSLATIONS } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';
import type { HeroChartSeries } from 'lumen/utils/constants/benchmark-insight/beni-hero-chart-constant-values';
import type { PaceChartSeries } from 'lumen/utils/constants/benchmark-insight/beni-pace-chart-constant-values';

export default class BenchmarkInsightBeniChartServiceService extends Service {
  @service('benchmark-insight/beni-service')
  declare benchmarkInsightBeniService: Services['benchmark-insight/beni-service'];
  @service declare intl: Services['intl'];

  getSeriesByComparisonSetType<
    Series extends HeroChartSeries | PaceChartSeries,
  >(chartSeries: Series[], comparisonSet: ComparisonSet): Series | null {
    return (
      chartSeries.find(
        (series) =>
          series.name ===
          this.intl.t(BENI_COMPARISON_SET_LONG_TRANSLATIONS[comparisonSet]),
      ) ?? null
    );
  }

  yAxisLabelFormatter(value: number, isPercentage: boolean): string {
    if (isPercentage) {
      const percentage = value * 100;
      // Use Math.round to round to one decimal place.
      const roundedValue = Math.round(percentage * 10) / 10;
      return `${roundedValue}%`;
    }

    return `${this.benchmarkInsightBeniService.formatNumber(value, 'currency', 'default')}`;
  }
}

declare module '@ember/service' {
  interface Registry {
    'benchmark-insight/beni-chart-service': BenchmarkInsightBeniChartServiceService;
  }
}
